import React, { useEffect, useState } from "react";
import "../Admin/css/header.css";
//import profileImg from "../profileimage/slide2.png";
import { FiLogOut } from "react-icons/fi";
import { secureStorage } from "../utils/secureStorage";
import { useNavigate } from "react-router-dom";
import { FiMoon, FiSun } from "react-icons/fi";


const Header = () => {
   const navigate = useNavigate();

  const [sidebarOpen, setSidebarOpen] = useState(false);
   const scholar = secureStorage.getScholar();

  const handleLogout = () => {
    // clear storage
    secureStorage.clear();


    // prevent back navigation
    window.history.pushState(null, "", "/");
     // Redirect to login/admin page
  navigate("/", { replace: true });

  // Prevent back button
  setTimeout(() => {
    window.history.pushState(null, "", "/");
  }, 0);
  };

  const [darkMode, setDarkMode] = useState(
  localStorage.getItem("theme") === "dark"
);

useEffect(() => {
  if (darkMode) {
    document.body.classList.add("dark-theme");
    localStorage.setItem("theme", "dark");
  } else {
    document.body.classList.remove("dark-theme");
    localStorage.setItem("theme", "light");
  }
}, [darkMode]);


useEffect(() => {
  const handleBackButton = () => {
    window.history.pushState(null, "", window.location.href);
  };

  window.history.pushState(null, "", window.location.href);

  window.addEventListener("popstate", handleBackButton);

  return () => {
    window.removeEventListener("popstate", handleBackButton);
  };
}, []);
  
  return (
    <div className="header">
      <div className="header-background-div">
      <div className="header-left">
      
       <div className="profile-avatars">
            {scholar?.user_name?.charAt(0)?.toUpperCase() || "U"}
          </div>
           <div className="user-details">
        <span className="username">{scholar?.user_name || "User"}</span>
        <span > ({scholar?.user_id})</span>
      </div>
</div>
</div>
<div className="header-right">

  <button
    className="theme-btn"
    onClick={() => setDarkMode(!darkMode)}
  >
    {darkMode ? <FiSun /> : <FiMoon />}
  </button>

  <button className="logout-btn" onClick={handleLogout}>
    <FiLogOut />
  </button>

</div>
      {/* <div className="header-right">
        <button className="logout-btn" onClick={handleLogout}>
         <FiLogOut />
        </button>
      </div> */}
    </div>
  );
};

export default Header;